import { CourseDescriptionCard } from '@components';
import { useScreenSize } from '@hooks';
import Camo from '@pngs/Camo.png';
import Compass from '@pngs/Compass.png';
import Tape from '@pngs/Tape.png';
import { Flex, Image } from '@styles';
import LogoSoldierLevel from '@svgs/logoSoldierLevel.svg';
import { arrayOf, object, string } from 'prop-types';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { sectionLayoutByVariant } from './CourseDescriptionSection.layoutProps';

const CourseDescriptionSection = ({ attitude, containerProps, knowledge }) => {
  const { i18n } = useTranslation();
  const { device, isLaptop, isTabletLG } = useScreenSize();
  const isAttitude = useMemo(
    () => (!attitude ? false : attitude[0]?.length > 0),
    [attitude]
  );
  const layout = sectionLayoutByVariant[device || 'desktop'];

  return (
    <Flex
      backgroundImage={Camo}
      backgroundSize="contain"
      flexDirection={layout.direction}
      position="relative"
      py={layout.py}
      {...(!isAttitude && { justifyContent: 'space-between' })}
      {...containerProps}
    >
      {isAttitude && (
        <Image
          position="absolute"
          src={Tape}
          width={200}
          zIndex={2}
          {...layout.tape}
        />
      )}
      {isAttitude && (
        <Image
          position="absolute"
          src={Compass}
          zIndex={-1}
          {...layout.compass}
        />
      )}
      {!isAttitude && (
        <Image
          src={LogoSoldierLevel}
          style={{
            filter: 'brightness(0)',
            width: isLaptop ? '336px' : '436px',
          }}
          {...(isTabletLG && {
            margin: 'auto',
            marginBottom: '20px',
          })}
        />
      )}
      <CourseDescriptionCard
        cardStyle={!isAttitude && { minWidth: '50%' }}
        descriptionPoints={knowledge}
        tagType="knowledge"
        title={i18n.t('SoldierLevelPage.ResultDescription.Knowledge.Title')}
      />
      {isAttitude && (
        <CourseDescriptionCard
          descriptionPoints={attitude}
          tagType="attitude"
          title={i18n.t('SoldierLevelPage.ResultDescription.Attitude.Title')}
        />
      )}
    </Flex>
  );
};

CourseDescriptionSection.propTypes = {
  attitude: arrayOf(string).isRequired,
  containerProps: object,
  knowledge: arrayOf(string).isRequired,
};

CourseDescriptionSection.defaultProps = {
  containerProps: {},
};

export default CourseDescriptionSection;
